define([
  /*eslint-disable */
  'js/aofl-js/0.8.0/app/app',
  'text!readingiq-src/js/riq-js/info-message-modal/1.0.0/index.html',
  'text!readingiq-src/js/riq-js/info-message-modal/1.0.0/index.css'
  /*eslint-enable */
], function directive(app, html, css) {
  'use strict';

  app.registerComponent(
    'infoMessageModal',
    function infoMessageModalComponent() {
      return {
        restrict: 'E',
        scope: {},
        transclude: true,
        bindToController: {},
        template: html,
        controller: 'InfoMessageModalController',
        controllerAs: 'infoMessageModalCtrl'
      };
    }
  );

  app.registerController('InfoMessageModalController', [
    '$scope',
    '$element',
    'compileService',
    function infoMessageModalController($scope, $element, compileService) {
      compileService.compile({css: css}, $scope, $element);
    }
  ]);
});
